import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
const useBlogsCMSData = () => {
  const { t } = useTranslation();

  const data = useMemo(
    () => ({
      data: {
        BlogsPage: {
          title: t('blogs_listing:er_blog_title'),
          heading: t('blogs_listing:er_blog_heading'),
          subTitle: t('blogs_listing:er_blod_subtitle'),
          searchPlaceholder: t('blogs_listing:search_er_blog'),
          sortByNewest: t('blogs_listing:sort_newest'),
          sortByOldest: t('blogs_listing:sort_oldest'),
          noResultsTitle: t('blogs_listing:no_results_title'),
          noResultsSubtitle: t('blogs_listing:no_results_subtitle'),
          backToBlogBtnText: t('blogs_listing:back_to_blog_btn'),
          backToMainBlogBtnText: t('blogs_listing:back_to_main_blog_btn'),
          resultsFoundText: t('blogs_listing:results_found'),
          noResultsIcon: {
            small_url: {
              url: '/imgs/Rebranding/common/no-plog-icon.png',
            },
            medium_url: {
              url: '/imgs/Rebranding/common/no-plog-icon.png',
            },
            large_url: {
              url: '/imgs/Rebranding/common/no-plog-icon.png',
            },
            alt: t('blogs_listing:no_results_titlee'),
          },
        },
      },
    }),
    [t],
  );

  return data;
};

export { useBlogsCMSData };
